export default class PlayerTableRow {
  leagueAvg = 0;
  totalAccumulated = 0;
  period1 = 0;
  period2 = 0;
  period3 = 0;
  period4 = 0;
  period5 = 0;
  period6 = 0;
  items = null;
  generalName = '';

  constructor(category, categoryIds, translationKey, nestedRows, generalName) {
    this.category = category;
    this.categoryIds = categoryIds;
    this.translationKey = translationKey;
    if (nestedRows) this.createItems(nestedRows);
    this.generalName = generalName;
  }

  createItems(items) {
    this.items = [];
    for (let item of items) {
      this.items.push(
        new PlayerTableRow(item.category, item.categoryIds, item.translationKey, item.items, item.generalName),
      );
    }
  }

  addAvgPlay(play, timeSelected, playValueIndex, seasonGames, parentRow) {
    // If this row has not categoryIds, it is a parent row
    if (this.categoryIds) {
      // Check if current play.categoryId is in categoryIds
      if (
        this.categoryIds.includes(play[playValueIndex.categoryId]) &&
        timeSelected.includes(play[playValueIndex.section])
      ) {
        // if this row has parent row, increment it's period
        if (parentRow) parentRow.leagueAvg += play[playValueIndex.total] / seasonGames;
        this.leagueAvg += play[playValueIndex.total] / seasonGames;
        return true;
      }
    } else if (this.items) {
      for (let item of this.items) {
        if (item.addAvgPlay(play, timeSelected, playValueIndex, seasonGames, this)) {
          return true;
        }
      }
    }
  }

  addPlay(play, timeSelected, playValueIndex, parentRow) {
    // If this row has not categoryIds, it is a parent row
    if (this.categoryIds) {
      // Check if current play.categoryId is in categoryIds
      if (this.categoryIds.includes(play[playValueIndex.categoryId])) {
        // if this row has parent row, increment it's period
        if (parentRow) parentRow[`period${play[playValueIndex.section]}`]++;
        this[`period${play[playValueIndex.section]}`]++;
        // Check selected time periods with current play time period
        if (!timeSelected || timeSelected.includes(play[playValueIndex.section])) {
          if (parentRow) parentRow.totalAccumulated++;
          this.totalAccumulated++;
        }
        return true;
      }
    } else if (this.items) {
      for (let item of this.items) {
        if (item.addPlay(play, timeSelected, playValueIndex, this)) {
          return true;
        }
      }
    }
  }
}
